import _ from 'lodash';
import JSONApiClient from '../jsonapi-service';

const getInfluencerCampaignPermissions = userId => {
  console.log('getInfluencerCampaignPermissions');
  const client = JSONApiClient();
  const options = {
    filter: {
      user: userId,
    },
    include: ['campaign'],
    sort: ['-createdDate'],
  };

  return client.find('campaignPermission', options)
    .then(permissions => {
      const campaignPermissions = [];
      _.forEach(permissions, permission => {
        campaignPermissions.push(permission.toJSONTree());
      });
      // Returns JSON object
      return campaignPermissions;
    });
};

module.exports = {
  getInfluencerCampaignPermissions,
};



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/influencer-campaigns.js
 **/